export const dashboardBannerSchema = {
	schema: {
		title: 'dashboard banner schema',
		description: 'Dashboard Banner Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			banner_url: {
				type: 'string',
			},
			banner_name: {
				type: 'string',
			},
			division_id: {
				type: 'string',
			},
			usertype: {
				type: 'array',
				items: {
					type: 'string',
				},
			},
			createddate: {
				type: 'string',
			},
			updateddate: {
				type: 'string',
			},
		},
		required: ['id', 'banner_url', 'banner_name', 'division_id', 'usertype', 'createddate', 'updateddate'],
	},
};
